import React, { FC, useId } from 'react'
import IconRecoverySeal from '../icons/IconRecoverySeal/IconRecoverySeal'
import { Check2 } from 'react-bootstrap-icons'
import IconChevronDownXs from '../icons/IconChevronDownXs/IconChevronDownXs'
import useSegment from '../../hooks/segment/useSegment'

export const WHY_TRUST_RECOVERY_TITLE = 'Why Trust Recovery.com'
export const WHY_TRUST_RECOVERY_DESCRIPTION =
  'Evidence and ethics matter to us. <a class="underline" href="https://recovery.com/about/">Since 2013</a>, our expert team has built comprehensive resources you can trust to find the right treatment for you.'
const WhyTrustRecovery: FC = () => {
  const segment = useSegment()
  const id = `why-trust-recovery-${useId()}`

  const handleClick = () => {
    const page = window.location.pathname
    const platform = 'desktop'

    const eventData = {
      page: page,
      platform: platform
    }
    segment.trustBlock.click(eventData)
  }

  return (
    <div className="group flex flex-col gap-4 rounded-2xl border border-gray-300 p-6">
      <IconRecoverySeal className="size-14" />
      {/* This checkbox is a trick to make TrustPoints toggleable
          before JS loads: https://css-tricks.com/the-checkbox-hack/ */}
      <input
        type="checkbox"
        className="hidden"
        id={id}
      />
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-medium text-gray-1100">
            {WHY_TRUST_RECOVERY_TITLE}
          </h2>
          <p
            className="text-sm text-gray-800"
            dangerouslySetInnerHTML={{ __html: WHY_TRUST_RECOVERY_DESCRIPTION }}
          />
        </div>
        <div className="hidden group-has-[:checked]:block">
          <TrustPoints />
        </div>
      </div>

      <label
        className="inline-flex h-6 cursor-pointer items-center self-stretch text-sm font-semibold text-gray-1100 hover:underline"
        htmlFor={id}
      >
        <span
          className="group-has-[:checked]:hidden"
          onClick={handleClick}
        >
          Learn More
        </span>
        <span className="hidden group-has-[:checked]:block">Show Less</span>
        <IconChevronDownXs
          strokeWidth="0.2"
          className="ml-0.5 text-gray-1100 group-has-[:checked]:rotate-180"
        />
      </label>
    </div>
  )
}

interface TrustPointProps {
  title: string
  description: string
  bgColor?: string
}

const TrustPoint: FC<TrustPointProps> = ({
  title,
  description,
  bgColor = 'bg-primary-50'
}) => {
  return (
    <div className="flex gap-3">
      <div
        className={`my-2 flex size-6 shrink-0 items-center justify-center rounded-full ${bgColor}`}
      >
        <Check2 className="size-4 text-gray-1100" />
      </div>
      <div className="flex flex-col">
        <h4 className="pb-0.5 text-sm font-medium text-gray-1100">{title}</h4>
        <p className="text-xs text-gray-800">{description}</p>
      </div>
    </div>
  )
}

interface TrustPointsProps {
  checksBgColor?: string
}

export const TrustPoints: FC<TrustPointsProps> = ({
  checksBgColor = 'bg-primary-50'
}) => {
  const trustPoints = [
    {
      title: 'Unbiased and independent resource',
      description: '100% editorially independent with no provider affiliations.'
    },
    {
      title: 'Accurate & comprehensive information',
      description:
        'Comprehensive provider profiles backed by 10+ years of research.'
    },
    {
      title: 'We are trusted by millions',
      description: 'Helped more than 4 million families with recovery.'
    },
    {
      title: 'We adhere to ethical standards',
      description:
        'Direct provider connections; we don’t profit from referrals.'
    }
  ]

  return (
    <div className="flex flex-col gap-3">
      {trustPoints.map((point, index) => (
        <TrustPoint
          key={index}
          title={point.title}
          description={point.description}
          bgColor={checksBgColor}
        />
      ))}
    </div>
  )
}

export default WhyTrustRecovery
